import { Record, List } from "immutable";
import moment from "moment";

const defaults = {
    id: undefined,
    warehouseId: undefined,
    accountCarrierId: undefined,
    serviceCode: null,
    createdOn: undefined,
    modifiedOn: undefined,
};

export class CarrierServiceWarehouseService extends Record(defaults) {
    declare id: string;
    declare warehouseId: string;
    declare accountCarrierId: string;
    declare serviceCode: any;
    declare createdOn: moment.Moment;
    declare modifiedOn: moment.Moment;

    constructor(args) {
        super({
            ...args,
            warehouseId: args.warehouse_id,
            accountCarrierId: args.shipping_account_carrier_id,
            serviceCode: args.service_code ? List(args.service_code) : null,
            createdOn: moment.utc(args.created_on),
            modifiedOn: moment.utc(args.modified_on),
        });
    }
}
